module.exports = __webpack_public_path__ + "img/defkf3.3cce3242.png";